import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { NumericFormat } from 'react-number-format';

// Services & Helpers
import FormHelper from 'helpers/FormHelper';
import API from 'API';

// Components
import Loader from 'components/common/Loader';

//-----------------------------------------------------------------

class EditDiscountModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.form = new FormHelper({
            fields: {
                name: {
                    label: 'Name (NOTE: customer can see this)',
                    type: 'text',
                    autoFocus: true
                },
                description: {
                    label: 'Description',
                    type: 'expanding-text',
                    rows: 2
                },
                discountType: {
                    label: 'Discount Type',
                    type: 'single-select',
                    getOptions: () => [
                        { value: 'Percentage', text: 'Percentage' },
                        { value: 'Fixed', text: 'Fixed £ Amount' }
                    ]
                },
                discountAmount: {
                    label: 'Discount Amount',
                    type: 'number'
                },
                startDate: {
                    label: 'Start Date (optional)',
                    type: 'date'
                },
                expiryDate: {
                    label: 'Expiry Date (optional, inclusive)',
                    type: 'date'
                },
                appliesToClean: {
                    label: 'Applicable to...',
                    boxLabel: 'Cleaning',
                    type: 'checkbox'
                },
                appliesToOtherService: {
                    boxLabel: 'Other Services',
                    type: 'checkbox'
                }
            },
            getValue: (fieldName) => this.getFieldValue(fieldName),
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                id: null,
                ...opt
            }, () => {
                this.load();
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async load() {
        const {
            id
        } = this.state;

        // Load discount
        let discount;
        if (id) {
            discount = await API.call('discount/get/' + id);
        } else {
            discount = {
                discountType: 'Percentage',
                appliesToClean: true,
                appliesToOtherService: true
            };
        }

        // Update
        this.setState({
            discount,
            isLoading: false
        });
    }
    
    getFieldValue(fieldName) {
        return this.state.discount[fieldName];
    }

    updateFields(fields) {
        const discount = { ...this.state.discount };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            discount[fieldName] = value;
        }
        this.setState({ discount });
    }

    updateServiceTypeFields(serviceTypeID, fields) {
        const serviceTypes = [...this.state.serviceTypes];
        const index = serviceTypes.findIndex(st => st.id == serviceTypeID);
        const serviceType = { ...serviceTypes[index] };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            serviceType[fieldName] = value;
        }
        serviceTypes[index] = serviceType;
        this.setState({ serviceTypes });
    }

    async saveAndClose() {
        const { discount } = this.state;
        this.setState({ isLoading: true });
        await API.call('discount/save', discount);
        this.close();
        this.resolve();
    }

    async confirmDelete() {
        const confirm = window.confirm('Are you sure you want to delete this discount?');
        if (confirm) {
            this.setState({ isLoading: true });
            await API.call('discount/delete/' + this.state.id);
            this.close();
            this.resolve();
        }
    }

    render() {
        const { 
            isOpen,
            isLoading,
            id,
            discount
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show onHide={() => this.close()} className="edit-discount-modal" backdrop="static" keyboard={false}>
                {isLoading ?
                    <Modal.Body><Loader /></Modal.Body> :
                    <form onSubmit={e => { this.saveAndClose(); e.preventDefault() }}>
                        {/*
                        <Modal.Header closeButton>
                            <Modal.Title></Modal.Title>
                        </Modal.Header>
                        */}
                        <Modal.Body>

                            {this.renderInner()}

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                                Cancel
                            </button>
                            {!!id &&
                                <button type="button" className="btn btn-secondary" onClick={() => this.confirmDelete()}>
                                    Delete
                                </button>
                            }
                            <button type="submit" className="btn btn-primary ms-auto">
                                Save Changes
                            </button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
        );
    }

    renderInner() {
        const { discount } = this.state;

        return (<>

            <fieldset>

                {this.form.render([
                    'name',
                    'description',
                    'discountType',
                    'discountAmount',
                    'startDate',
                    'expiryDate',
                    (discount.discountType == 'Percentage' && 'appliesToClean'),
                    (discount.discountType == 'Percentage' && 'appliesToOtherService')
                ])}

            </fieldset>

        </>);
    }
}

export default EditDiscountModal;